import { BrandThemeConfig, TOfficeInfo } from '@/types';
import { FacilityFieldsFragment } from '@/graphql/__generated/sdk';
import { replaceUrlContentVars } from '@/utils/replaceUrlContentVars/replaceUrlContentVars';
import { foundVarInPath, getHasOfficeInfo, replaceContentVars } from '@/utils/replaceContentVars/replaceContentVars';

export type ResolveEntryLinkArgs = {
	path?: string;
	typeName: string;
	config: BrandThemeConfig;
	officeInfo: FacilityFieldsFragment | null;
	officeLocationInfo: TOfficeInfo | null;
};

export const getCleanPhoneNumberString = (phoneNumber: string | undefined | null): string => {
	if (!phoneNumber) return '';
	return phoneNumber.replace(
		/^(\+)?(.*)/,
		(match: string, plus: string | undefined, rest: string) => (plus || '') + rest.replace(/\D/g, '')
	);
};

export const resolveEntryLink = ({
	path = '',
	typeName,
	config,
	officeInfo,
	officeLocationInfo,
}: ResolveEntryLinkArgs) => {
	const blogRootPath = config?.features?.blogs?.root;
	const facilityBasePath = config?.features?.otherApps?.facilityDetailsBasePath;
	const hasOfficeInfo = getHasOfficeInfo(officeInfo, officeLocationInfo);

	if (hasOfficeInfo && foundVarInPath(path)) {
		return replaceContentVars({ text: path, officeInfo, officeLocationInfo, config, isHref: true });
	}

	switch (typeName) {
		case 'BlogDetailsPage':
			return `${blogRootPath}${path}/`;
		case 'BlogListPage':
			return `${blogRootPath}`;
		case 'FacilityDetailsPage':
		case 'ServiceDetailsPage':
			return hasOfficeInfo
				? replaceUrlContentVars(path, officeInfo, officeLocationInfo, config, typeName)
				: `/${facilityBasePath}`;
		default:
			return path || '';
	}
};
